export default {
  features: {
    approveRejectCaseRefund: {
      button: 'Tasdiqlash',
      successAlert: 'Qaytarish tasdiqlandi!',
    },
  },
};
